import React from 'react'
import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline'
import { useLoadboardTheme } from './loadboardTheme'
import { makeInputBase } from './FilterFields'
import EquipmentDropdown from './EquipmentDropdown'
import LocationField from './LocationField'
import PickDateRangeField from './PickDateRangeField'

const DH_OPTIONS = [25, 50, 75, 100, 125, 150, 200, 250]

function SearchFilters({
	filters,
	onChange,
	equipmentFlashKey = 0,
	originFlashKey = 0,
	onSaveSearch,
	onOpenManageSearches,
}) {
	const { theme, tokens } = useLoadboardTheme()
	const isLight = theme === 'light'
	const inputBase = makeInputBase(tokens)

	const set = patch => onChange({ ...filters, ...patch })

	const swap = () =>
		onChange({
			...filters,
			origin: filters.destination,
			originLat: filters.destinationLat,
			originLng: filters.destinationLng,
			originDh: filters.destinationDh,
			destination: filters.origin,
			destinationLat: filters.originLat,
			destinationLng: filters.originLng,
			destinationDh: filters.originDh,
		})

	return (
		<div className="flex flex-col gap-2">
			<div className="flex items-end gap-2 flex-wrap">
					<LocationField
						value={filters.origin}
						onChange={(v, coords) =>
							set({
								origin: v,
								originLat: coords ? coords.lat : null,
								originLng: coords ? coords.lng : null,
							})
						}
						placeholder="e.g. Atlanta, GA"
						label="Origin"
						tokens={tokens}
						inputBase={inputBase}
						flashKey={originFlashKey}
						storageKey="loadboard.recentOrigins"
						radiusValue={filters.originDh}
						onRadiusChange={v => set({ originDh: v })}
						radiusOptions={DH_OPTIONS}
					/>

					<button
						type="button"
						onClick={swap}
						className={`self-end -mx-1 flex items-center justify-center w-8 h-8 rounded-full ${tokens.swapBtn}`}
						aria-label="Swap origin and destination"
						title="Swap origin and destination"
					>
						<ArrowsRightLeftIcon className="h-[18px] w-[18px]" strokeWidth={2.5} />
					</button>

					<LocationField
						value={filters.destination}
						onChange={(v, coords) =>
							set({
								destination: v,
								destinationLat: coords ? coords.lat : null,
								destinationLng: coords ? coords.lng : null,
							})
						}
						placeholder="Anywhere"
						label="Destination"
						tokens={tokens}
						inputBase={inputBase}
						storageKey="loadboard.recentDestinations"
						radiusValue={filters.destinationDh}
						onRadiusChange={v => set({ destinationDh: v })}
						radiusOptions={DH_OPTIONS}
					/>

					<div className="self-end h-8 mx-2 border-l-2 border-gray-400" aria-hidden="true" />

					<EquipmentDropdown
						value={filters.equipment}
						onChange={next => set({ equipment: next })}
						flashKey={equipmentFlashKey}
					/>

				<PickDateRangeField
						from={filters.pickDateFrom}
						to={filters.pickDateTo}
						onChange={set}
						tokens={tokens}
						inputBase={inputBase}
						isLight={isLight}
					/>
			</div>
		</div>
	)
}

export default SearchFilters
